import { Card, CardContent } from "@/components/ui/card"
import { ArrowUpRight, ArrowDownRight } from "lucide-react"
import { Separator } from "@/components/ui/separator"
import { PatientStat } from "../-data/fixtures"

interface StatsCardsProps {
  stats: PatientStat[]
}

export function StatsCards({ stats }: StatsCardsProps) {
  return (
    <Card className="rounded-xl shadow-sm border bg-white">
      <CardContent className="p-0">
        <div className="flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x">
          {stats.map((stat, index) => {
            const Icon = stat.icon
            const isUp = stat.trendDirection === "up"
            
            return (
              <div key={index} className="flex-1 p-6">
                <div className="flex justify-between items-start mb-4">
                  <span className="text-sm font-medium text-muted-foreground">{stat.label}</span>
                  <Icon className="h-5 w-5 text-muted-foreground/50" />
                </div>
                
                <div className="text-2xl font-bold mb-4">{stat.value}</div>
                
                <div className="flex items-center text-xs">
                  <div className={`flex items-center mr-2 ${isUp ? "text-emerald-600" : "text-rose-600"}`}>
                    {isUp ? (
                      <ArrowUpRight className="h-3 w-3 mr-1" />
                    ) : (
                      <ArrowDownRight className="h-3 w-3 mr-1" />
                    )}
                    <span className="font-medium">{stat.trend}</span>
                  </div>
                  <span className="text-muted-foreground">{stat.trendLabel}</span>
                </div>
              </div>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
